// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 6.5V7.46C3 10.22 5.24 12.46 8 12.46M13 6.5V7.46C13 10.22 10.76 12.46 8 12.46M8 12.46V14M8 10.12C6.53 10.12 5.33 8.86 5.33 7.31V4.86C5.33 3.31 6.53 2.05 8 2.05C9.47 2.05 10.67 3.31 10.67 4.86V7.31C10.67 8.86 9.47 10.12 8 10.12Z',
];
